import { createTheme } from '@one-thd/sui-atomic-components';

const DecorDaysOrange = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

DecorDaysOrange.palette['--sui-palette-background-primary'] = '249 147 84';

export { DecorDaysOrange };
